import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';

const Main: React.FC = () => {
  return (
    <Box>
      <Box>
        <Text size="header" fontWeight="bold" color="primaryText">
          Landing Zones
        </Text>
      </Box>
      <Box mt={20}>
        <Text size="normal" color="primaryText">
          Manage air ambulance landing zones for your ECC. Placeholder content.
        </Text>
      </Box>
    </Box>
  );
};

export default Main;
